export const AI_MODEL_TYPE_OPTIONS = ['di', 'ai_foundry'] as const;
